import React, { Component } from "react";
import styled from "styled-components";
import LineModal from "./LineModal";
import WhatsappModal from "./WhatsappModalWithMutation";
import LivechatModal from "./LivechatModalWithMutation";
import Panel from "../common/Panel";
import AddButtonRaw from "../common/AddButton";
import AddModal from "./AddModal";
import List from "./ListWithQuery";

export default class ChannelPanel extends Component {
  state = {
    showAddModal: false,
    showLineModal: false,
    showWhatsappModal: false,
    showLivechatModal: false
  };

  render() {
    return (
      <Panel title="ACCOUNT">
        <AddButton onClick={() => this.setState({ showAddModal: true })}>
          + Add New Account
        </AddButton>
        <List />
        {this.state.showAddModal && (
          <AddModal
            onClick={this.onAddModalClick}
            onClose={() => this.setState({ showAddModal: false })}
          />
        )}
        {this.state.showLineModal && (
          <LineModal
            text="Add LINE Channel"
            onCancel={this.hideModal}
            onConfirm={this.hideModal}
          />
        )}
        {this.state.showWhatsappModal && (
          <WhatsappModal
            text="Add Whatsapp Channel"
            onCancel={this.hideModal}
            onConfirm={this.hideModal}
          />
        )}
        {this.state.showLivechatModal && (
          <LivechatModal
            text="Add Livechat Channel"
            onCancel={this.hideModal}
            onConfirm={this.hideModal}
          />
        )}
      </Panel>
    );
  }

  onAddModalClick = channel => {
    if (channel === "line") {
      this.setState({
        showAddModal: false,
        showLineModal: true
      });
    } else if (channel === "whatsapp") {
      this.setState({
        showAddModal: false,
        showWhatsappModal: true
      });
    } else if (channel === "livechat") {
      this.setState({
        showAddModal: false,
        showLivechatModal: true
      });
    }
  };

  hideModal = () => {
    this.setState({
      showLineModal: false,
      showWhatsappModal: false,
      showLivechatModal: false
    });
  };
}

const AddButton = styled(AddButtonRaw)`
  margin-top: 10px;
  margin-bottom: 16px;
`;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/channel-panel/ChannelPanel.js